import { gql } from '@at/sauron-platform-graphql';
export const vehicleCardCollectionLiteQuery = gql `
    query VehicleCardCollectionLiteSearchQuery(
        $make: [String]
        $model: [String]
        $bodyType: [String]
        $excludeBodyType: [String]
        $fuelType: [String]
        $aggregatedTrim: [String]
        $transmission: [String]
        $colour: [String]
        $advertisingLocations: [AdvertisingLocation]
        $dealerId: [String]
        $condition: [Condition]
        $sort: Sort
        $limit: Int
        $isManufacturerApproved: Boolean
        $postcode: String
        $distance: Int
        $minPrice: Int
        $maxPrice: Int
        $minEngineSize: Float
        $maxEngineSize: Float
        $minManufactureYear: String
        $maxManufactureYear: String
        $minSeats: Int
        $maxSeats: Int
        $latLong: String
        $hasImages: Boolean
        $searchOptions: SearchOptions
        $leaseOption: String
        $leaseContractType: LeaseContractType
        $leaseOfferTypes: [LeaseOfferType]
        $showSpecification: Boolean = false
    ) {
        search {
            adverts(
                advertQuery: {
                    make: $make
                    model: $model
                    bodyType: $bodyType
                    excludeBodyType: $excludeBodyType
                    fuelType: $fuelType
                    aggregatedTrim: $aggregatedTrim
                    transmission: $transmission
                    colour: $colour
                    advertisingLocations: $advertisingLocations
                    dealerId: $dealerId
                    condition: $condition
                    isManufacturerApproved: $isManufacturerApproved
                    postcode: $postcode
                    distance: $distance
                    minPrice: $minPrice
                    maxPrice: $maxPrice
                    minEngineSize: $minEngineSize
                    maxEngineSize: $maxEngineSize
                    minYear: $minManufactureYear
                    maxYear: $maxManufactureYear
                    minSeats: $minSeats
                    maxSeats: $maxSeats
                    latLong: $latLong
                    hasImages: $hasImages
                    leaseOption: $leaseOption
                    leaseContractType: $leaseContractType
                    leaseOfferTypes: $leaseOfferTypes
                }
                sort: $sort
                searchOptions: $searchOptions
            ) {
                advertList(limit: $limit) {
                    adverts {
                        id
                        title
                        condition
                        attentionGrabber
                        price
                        rrp
                        saving
                        imageList {
                            images {
                                templated
                                url
                            }
                        }
                        video {
                            url
                            preview
                        }
                        priceIndicatorRating
                        priceIndicatorRatingLabel
                        plate
                        mileage {
                            mileage
                            unit
                        }
                        year
                        coreSpecification: specification {
                            make
                            model
                            derivative
                        }
                        additionalSpecification: specification @include(if: $showSpecification) {
                            seats
                            doors
                            bodyType
                            fuel
                            transmission
                            battery {
                                range {
                                    range
                                    unit
                                }
                            }
                            techData {
                                badgeEngineSize
                            }
                        }
                        locationArea {
                            region
                        }
                        leasingOffers {
                            providerAdvertiserId
                            offerType
                            externalOfferId
                            depositMonths
                            termMonths
                            totalMileage
                            monthlyPrice
                            monthlyPriceExVat
                            adminFee
                            deliveryEstimateDays
                        }
                    }
                }
            }
        }
    }
`;
